import React from 'react';

import Image from 'next/image';
import { FaUserAstronaut } from 'react-icons/fa';
import { HiCollection, HiShieldCheck } from 'react-icons/hi';
import { useBoolean } from 'usehooks-ts';

import { IUserData } from '@/modules/core/types';
import Text from '@/tayara-kit/Text';

const isTrusted = false;

type ItemPublisherCardType = {
  userDetails: IUserData;
  countAdByUser: number;
  showCountAds: boolean;
};
const ItemPublisherCard = React.forwardRef<
  HTMLDivElement,
  ItemPublisherCardType
>(
  (
    { userDetails, countAdByUser, showCountAds }: ItemPublisherCardType,
    ref
  ) => {
    const { value: brokenImage, setValue: setBrokenImage } = useBoolean(false);

    const userAvatar = userDetails.avatar || '';

    const { isShop } = userDetails;

    return (
      <div
        ref={ref}
        className={`w-fit flex flex-col md:flex-col pb-4 ml-4 mr-2`}
      >
        {/* Card header */}
        {/* <div
          className={` flex justify-start ${
            userDetails.isShop ? 'md:min-h-[10px]' : 'min-h-[100px]'
          }`}
        > */}
        <div className="flex flex-col justify-center">
          {/* Large avatar */}
          <div
            className={`flex items-center justify-center mx-auto transition-transform active:scale-90`}
          ></div>
          {/* Trusted badge */}
          {isTrusted && (
            <span className="mt-4 badge bg-lime-600/80 text-white gap-x-0.5 mx-auto">
              <HiShieldCheck size={11} /> Trusted
            </span>
          )}
        </div>
        <div
          className={` md:flex ml-2  ${
            userDetails.isShop ? 'items-center' : 'items-center'
          }`}
        >
          <div className="flex flex-col">
            <div className="flex flex-col md:flex-row lg:flex-row items-center">
              <div
                className={`avatar relative ${
                  isShop ? 'mb-2 md:mb-4 lg:mb-0 ' : 'mb-0'
                }`}
              >
                <div className="mask mask-squircle absolute left-[-1px] top-[-1px] w-[72px] bg-white"></div>
                <div className={`mask mask-squircle w-[70px]`}>
                  {userDetails.avatar && !brokenImage ? (
                    <Image
                      loading="lazy"
                      width={90}
                      height={90}
                      className="w-full"
                      unoptimized
                      src={
                        userAvatar.includes('http')
                          ? `https://www.tayara.tn/mediaGateway/resize-image?img=${userAvatar.substring(
                              userAvatar.lastIndexOf('/') - 2
                            )}&w=100`
                          : `https://www.tayara.tn/mediaGateway/resize-image?img=${userAvatar}&w=100`
                      }
                      alt="tayara publisher profile picture"
                      onError={() => setBrokenImage(true)}
                      onLoadingComplete={(result) => {
                        if (result.naturalWidth === 0) {
                          // If the naturalWidth of the image is 0 -> Broken image
                          setBrokenImage(true);
                        }
                      }}
                    />
                  ) : (
                    <div className="bg-primary/10 text-primary p-2">
                      <FaUserAstronaut className="" size={'100%'} />
                    </div>
                  )}
                </div>
              </div>

              <div className="flex flex-col lg:ml-4 md:ml-4 ml-0">
                {/*  Metadata */}
                <span
                  className={`text-2xs mt-0 md:mt-0 lg:mt-4 font-light text-gray-500`}
                >
                  <div className="flex-col flex  mb-3">
                    {/* Boutique data */}
                    {userDetails.isShop && (
                      <Text
                        text="Boutique"
                        className="text-xs text-center md:text-start lg:text-start font-normal leading-5 text-blue-500"
                      />
                    )}
                    {/* Publisher name on mobile devices */}
                    <Text
                      text={
                        userDetails.fullname?.toLowerCase() || ' sur tayara'
                      }
                      className="text-sm text-center md:text-start lg:text-start font-semibold text-gray-700 capitalize"
                    />{' '}
                    {/* Publisher number of listings */}
                    {showCountAds && (
                      <div
                        className={`flex justify-center flex-wrap md:justify-start lg:justify-start items-center space-x-1 mb-1 ${
                          userDetails.isShop
                            ? 'text-blue-800/60 '
                            : 'text-gray-600'
                        }`}
                      >
                        <Text
                          className="text-xs font-normal"
                          text={`${countAdByUser} annonce(s)`}
                        />
                        <HiCollection size={16} />
                      </div>
                    )}
                  </div>

                  {/* Shop location */}
                  {userDetails.address && (
                    <div
                      className={`w-fit flex items-start space-x-1 mb-1 text-blue-800/60`}
                    >
                      <Text
                        className="text-xs text-center md:text-start lg:text-start font-normal"
                        text={userDetails.address || ''}
                      />
                    </div>
                  )}
                </span>
              </div>
            </div>

            {/* Web devices divider */}
            {/* <Divider
              className={`hidden md:block !m-2  ${userDetails.isShop ? 'bg-blue-200' : ''
                }`}
              orientation={Orientation.HORIZONTAL}
            /> */}
            {/* Mobile devices divider */}
            {/* <Divider
              className={`block md:hidden h-[120px] ${userDetails.isShop ? 'bg-blue-200' : ''
                }`}
              orientation={Orientation.VERTICAL}
            /> */}
          </div>
        </div>

        {/* Strore icon detail */}
        {/* {userDetails.isShop && (
          <div
            className={`mask mask-squircle p-2 w-[30px] bg-blue-500 text-white mt-4 mx-auto hidden md:block`}
          >
            <MdStore size={16} className="w-full h-full" />
          </div>
        )} */}
      </div>
    );
  }
);

ItemPublisherCard.displayName = 'ItemPublisherCard';

export default ItemPublisherCard;
